export enum ProductTypeUrl {
    package = 1,
    experience = 2,
    accommodation = 3,
    travelPasses = 4,
    expressBooking = 5,
    manageBooking = 6
}



// WEBPACK FOOTER //
// ./src/app/shared/models/enums/ProductTypeUrl.enum.ts